module.exports = __webpack_public_path__ + "img/002.d8dbbb04.png";